import type { ElectaTrustee, E2E } from "@/types";

const trusteeMixingPackage = (trustee: ElectaTrustee, resultOrchestrator: E2E.ResultOrchestrator) => 
  resultOrchestrator.mixingPackages?.find((mixPackage) => mixPackage.trusteeUUID === trustee.uuid);

const trusteeDecryptionPackage = (trustee: ElectaTrustee, resultOrchestrator: E2E.ResultOrchestrator) =>
  resultOrchestrator.decryptionPackages?.find((dPackage) => dPackage.trusteeUUID === trustee.uuid);

const calculateTrusteeMixingStatus = (trustee: ElectaTrustee, resultOrchestrator: E2E.ResultOrchestrator) =>
  trusteeMixingPackage(trustee, resultOrchestrator)?.status || "initial";

const calculateTrusteeDecryptionStatus = (trustee: ElectaTrustee, resultOrchestrator: E2E.ResultOrchestrator) =>
  trusteeDecryptionPackage(trustee, resultOrchestrator)?.status || "initial";

export {
  trusteeMixingPackage,
  trusteeDecryptionPackage,
  calculateTrusteeMixingStatus,
  calculateTrusteeDecryptionStatus,
};
